import { EventEmitter } from "../../../node_modules/eventemitter3/index";
import { ISelect2, Stage, StagesClient, Strategy, TipoLista, UserAndRolesClient } from "../client/Client";
import events from "../Events/EventList";
import { UsuariosInternosService } from "../Services/UsuariosInternosService";
import Store from "../Store";
import { addOptionsToSelect, createOptions } from "../Utilities/Select";

const NOT_FINAL = "0";
const IS_FINAL = "1";
const IS_EDITABLE = "1";
const NOT_EDITABLE = "0";
const SIN_ESTRATEGIA = "0";
const UNIQUE_USER = "1";
const ROUND_ROBIN = "2";
const MANUAL = "7";
const GRUPO_BASADO_EN_ROL = "8";
const ASIGNACION_REMOTA = "9";

let select2Config = {
  maximumSelectionLength: 10,
  language: {
    maximumSelected: function (e) {
      var t = "Solo puede seleccionar " + e.maximum + " Usuario";
      e.maximum != 1 && (t += "s");
      return t;
    },
  },
};

let select2ConfigRoles = {
  ajax: {
    url: './api/UserAndRoles/roles',
    data: function (params) {
      var query = {
        nombre: params.term
      }

      // Query parameters will be ?search=[term]&type=public
      return query;
    }
  },
  
};

let select2ConfigUsuarios = {
  maximumSelectionLength: 50,
  ajax: {
    url: './api/UserAndRoles/users',
    data: function (params) {
      var query = {
        username: params.term
      }

      // Query parameters will be ?search=[term]&type=public
      return query;
    }
  },
  language: {
    maximumSelected: function (e) {
      var t = "Solo puede seleccionar " + e.maximum + " Usuario";
      e.maximum != 1 && (t += "s");
      return t;
    },
  },
};

export default class StageComponent {
  initUsuarioSelect(strategyId: number, tipoLista: string) {
    if (
      strategyId != parseInt(ROUND_ROBIN) &&
      strategyId != parseInt(UNIQUE_USER) &&
      strategyId != parseInt(MANUAL) &&
      strategyId != parseInt(GRUPO_BASADO_EN_ROL)
    ) {
      this.$TipoAsignacionUserGroup.setAttribute("disabled", "disabled");
    } else {
      this.$TipoAsignacionUserGroup.removeAttribute("disabled");
    }
    if (strategyId == parseInt(ROUND_ROBIN) || ( strategyId == parseInt(MANUAL) && tipoLista == TipoLista.USUARIOS.toString())
    || ( strategyId == parseInt(GRUPO_BASADO_EN_ROL) && tipoLista == TipoLista.GRUPO_BASADO_EN_ROL.toString())
    ) {
      this.$TipoAsignacionUserGroup.setAttribute("multiple", "multiple");
    } else {
      this.$TipoAsignacionUserGroup.removeAttribute("multiple");
    }
    if (this.$usuariosSelect2) this.$usuariosSelect2.select2("destroy");
    let conf =strategyId == parseInt(MANUAL) && tipoLista == TipoLista.USUARIOS.toString()
       ? select2ConfigUsuarios 
       : ((strategyId == parseInt(MANUAL) && tipoLista == TipoLista.ROL.toString())||(strategyId == parseInt(GRUPO_BASADO_EN_ROL) && tipoLista == TipoLista.GRUPO_BASADO_EN_ROL.toString()) )
       ? select2ConfigRoles
       : select2Config;
    this.$usuariosSelect2 = $(this.$TipoAsignacionUserGroup).select2(
      conf
    );
  }
  $usuariosSelect2: any = null;
  $name = <HTMLInputElement>document.querySelector("#stage-name");
  $id = <HTMLInputElement>document.querySelector("#stage-id");
  $stageForm = <HTMLFormElement>document.querySelector("#stage-main-form");
  $isFinal = <HTMLSelectElement>document.querySelector("#isFinal");
  $isEditable = <HTMLSelectElement>document.querySelector("#stage-is-editable");
  $plantillaFormularId = <HTMLSelectElement>(
    document.querySelector("#plantillaId")
  );
  $editControls = <HTMLDivElement>(
    document.querySelector("#stage-edit-controls")
  );
  $addStageBtn = <HTMLButtonElement>document.querySelector("#add-stage-btn");
  $strategy = <HTMLSelectElement>document.querySelector("#strategy");
  $tipoLista = <HTMLSelectElement>document.querySelector("#tipoLista");
  $strategyContainer = <HTMLDivElement>document.querySelector("#strategy-div");
  $UrlServicio = <HTMLInputElement>document.querySelector("#UrlServicio");
  $TipoAsignacionUserGroup = <HTMLSelectElement>(
    document.querySelector("#TipoAsignacionUserGroup")
  );
  $cssIcon = <HTMLInputElement>document.querySelector("#cssIcon");
  $cssIconPreview = <HTMLInputElement>document.querySelector("#preview-cssIcon");

  /**
   *
   */
  constructor(
    private stagesClient: StagesClient,
    private eventEmitter: EventEmitter,
    private store: Store,
    private usuariosInternos: UsuariosInternosService,
    private userAnRoles: UserAndRolesClient
  ) {
    this.$stageForm.onsubmit = this.formSubmitHandler;
    this.$stageForm.onreset = this.formResetHandler;
    this.$isFinal.onclick = this.isFinalChangeHandler;
    this.eventEmitter.on(events.STAGE_DELETED, this.clearIfId);
    this.eventEmitter.on(events.STAGE_SELECTED, this.setEditValuesHandler);
    this.redrawUsuarioAsignable(
      parseInt(this.$strategy.value),
      parseInt(this.$plantillaFormularId.value),
      this.$tipoLista.value,
      this.$UrlServicio.value
    );
    this.$plantillaFormularId.onchange = () => {
      this.redrawUsuarioAsignable(
        parseInt(this.$strategy.value),
        parseInt(this.$plantillaFormularId.value),
        this.$tipoLista.value,
        this.$UrlServicio.value
      );
      this.eventEmitter.emit(
        events.PLANTILLA_ID_CHANGED,
        parseInt(this.$plantillaFormularId.value)
      );

      this.$stageForm.reset();
      this.formResetHandler();
    };
    this.$tipoLista.onchange = () =>{
      this.initUsuarioSelect(parseInt(this.$strategy.value)
      ,this.$tipoLista.value)
    }
    this.$strategy.onchange = () => {
      this.redrawUsuarioAsignable(
        parseInt(this.$strategy.value),
        parseInt(this.$plantillaFormularId.value),
        this.$tipoLista.value,
        this.$UrlServicio.value
      );

    };
  }

  fetchInternalUsers = async () => {
    let usuarios = await this.usuariosInternos.GetNames(
      this.$plantillaFormularId.value
    );
    var options = createOptions(
      usuarios,
      (u) => u.id.toString(),
      (u) => u.text
    );
    addOptionsToSelect(this.$TipoAsignacionUserGroup, options);
    this.$TipoAsignacionUserGroup.value = "";
  };

  redrawUsuarioAsignable = async (strategyId: number, plantillaId: number, tipoLista: string, urlService: string) => {
    this.$TipoAsignacionUserGroup.innerText = "";
    this.$usuariosSelect2
    await this.fetchInternalUsers();
    this.$UrlServicio.value = urlService;
    if(parseInt(ASIGNACION_REMOTA) == strategyId ){
      this.$UrlServicio.removeAttribute("disabled");
      this.$tipoLista.setAttribute("disabled","disabled");
    }
    else {
      this.$UrlServicio.setAttribute("disabled","disabled");
      if(strategyId == parseInt(MANUAL) || strategyId == parseInt(GRUPO_BASADO_EN_ROL)){
        this.$tipoLista.removeAttribute("disabled");
      }
      else{
        this.$tipoLista.setAttribute("disabled","disabled");
        this.$tipoLista.value = TipoLista.USUARIOS.toString();
      }
    }

    
    
    this.initUsuarioSelect(strategyId, tipoLista);
  };

  clearIfId = (id: number) => {
    if (this.$id.value === id.toString()) {
      this.$stageForm.reset();
    }
  };

  isFinalChangeHandler = () => {
    if (this.$isFinal.value === IS_FINAL) {
      this.$strategyContainer.style.display = "none";
      this.$strategy.value = SIN_ESTRATEGIA;
      this.$TipoAsignacionUserGroup.value = "";
    } else {
      this.$strategyContainer.style.display = "";
    }
  };

  setEditValuesHandler = async (stage: Stage) => {
    this.$id.value = stage.id.toString();
    this.$name.value = stage.name;
    this.$isFinal.value = stage.isFinal ? IS_FINAL : NOT_FINAL;
    this.$isEditable.value = stage.isEditable ? IS_EDITABLE : NOT_EDITABLE;
    this.$editControls.style.display = "inline-block";
    this.$addStageBtn.style.display = "none";
    this.$strategy.value = stage.strategy.toString();
    this.$cssIcon.value = stage.cssIcon;
    this.$cssIconPreview.classList.value = stage.cssIcon;

    this.$strategyContainer.style.display = stage.isFinal ? "none" : "";
    if (!stage.isEditable) {
      this.$isFinal.setAttribute("disabled", "disabled");
      this.$strategy.setAttribute("disabled", "disabled");
      this.$TipoAsignacionUserGroup.setAttribute("disabled", "disabled");
      this.$tipoLista.setAttribute("disabled","disabled");
      this.$tipoLista.value = TipoLista.USUARIOS.toString();
      if (this.$usuariosSelect2) this.$usuariosSelect2.select2("destroy");
      this.$usuariosSelect2 = $(this.$TipoAsignacionUserGroup).select2(
        select2Config
      );
    } else {
      this.$tipoLista.value = stage.tipoLista.toString();
      await this.redrawUsuarioAsignable(
        stage.strategy,
        stage.plantillaFormularioId,
        stage.tipoLista.toString(),
        stage.urlServicio
      );
      if (stage.strategy == parseInt(UNIQUE_USER)) {
        this.$usuariosSelect2.val(stage.responsible);
        this.$usuariosSelect2.trigger("change");
      }
      if (stage.strategy == parseInt(ROUND_ROBIN)) {
        let ids = stage.responsiblesInGroup.split(",");
        if (ids.length) {
          this.$usuariosSelect2.val(ids);
          this.$usuariosSelect2.trigger("change");
        }
      }
      if (stage.strategy == parseInt(MANUAL) && stage.tipoLista == TipoLista.USUARIOS) {
        let usuarios = await this.userAnRoles.descripcionUsuarios(stage.responsiblesInGroup);
        if (usuarios.results?.length) {
          this.AddOptionsToSelect2(usuarios.results);
        }
      }

      if ((stage.strategy == parseInt(MANUAL) && stage.tipoLista == TipoLista.ROL)) {
        let rol = await this.userAnRoles.descripcionRoles(stage.responsible);
        if (rol.results?.length) {
          this.AddOptionsToSelect2(rol.results);
        }
      }

      if ((stage.strategy == parseInt(GRUPO_BASADO_EN_ROL) && stage.tipoLista == TipoLista.GRUPO_BASADO_EN_ROL)) {
        let rol = await this.userAnRoles.descripcionRoles(stage.responsiblesInGroup);
        if (rol.results?.length) {
          this.AddOptionsToSelect2(rol.results);
        }
      }
    }
  };

  AddOptionsToSelect2 = (values: ISelect2[])=>{
    for(let v of values){
      let option = new Option(v.text, v.id,true,true);
      $(this.$usuariosSelect2).append(option)
    }

    $(this.$usuariosSelect2).trigger('change');
  }
  formResetHandler = () => {
    this.$editControls.style.display = "none";
    this.$addStageBtn.style.display = "";
    this.$strategyContainer.style.display = "";
    this.$isFinal.removeAttribute("disabled");
    this.$strategy.removeAttribute("disabled");
    this.$cssIconPreview.classList.value = "";
    this.redrawUsuarioAsignable(0, parseInt(this.$plantillaFormularId.value), "PERSONALIZADO", "");
  };

  formSubmitHandler = async (evt: Event) => {
    evt.preventDefault();

    if (this.$name.value === "") {
      Alerta.SwalError("Debe ingresar un nombre para la etapa ");
      return false;
    }

    let stage = new Stage();
    stage.id = parseInt(this.$id.value);
    stage.name = this.$name.value;
    stage.isFinal = this.$isFinal.value === "1";
    stage.isEditable = this.$isEditable.value === "1";
    stage.strategy = parseInt(this.$strategy.value);
    stage.plantillaFormularioId = parseInt(this.$plantillaFormularId.value);
    stage.responsible = "";
    stage.responsiblesInGroup = "";
    stage.tipoLista = parseInt(this.$tipoLista.value);
    stage.cssIcon = this.$cssIcon.value;
    stage.urlServicio = this.$UrlServicio.value;
    if(stage.strategy == parseInt(ASIGNACION_REMOTA)){
      try{
        const x = new URL(stage.urlServicio);
      }catch{
        Alerta.SwalError("Url Servicio no valida");
      }
    }

    if (this.$strategy.value == UNIQUE_USER || (this.$strategy.value == MANUAL && this.$tipoLista.value == TipoLista.ROL.toString())) {
      stage.responsible = this.$TipoAsignacionUserGroup.value;
    }
    if (this.$strategy.value == ROUND_ROBIN || (this.$strategy.value == MANUAL && this.$tipoLista.value == TipoLista.USUARIOS.toString())
    || (this.$strategy.value == GRUPO_BASADO_EN_ROL && this.$tipoLista.value == TipoLista.GRUPO_BASADO_EN_ROL.toString())
    ) {
      let values = $(this.$TipoAsignacionUserGroup).val();
      if (values instanceof Array) {
        stage.responsiblesInGroup = values.join(",");
      }
    }

    if (!stage.isFinal && stage.strategy === parseInt(SIN_ESTRATEGIA)) {
      Alerta.SwalError(
        "Cuando la etapa no es final debe indicar una estrategia"
      );
      return false;
    }

    if (stage.id != 0) await this.updateStage(stage);
    else {
      await this.addStage(stage);
    }

    return false;
  };
  addStage = async (stage: Stage) => {
    try {
      let newStage = await this.stagesClient.post(stage);

      this.eventEmitter.emit(events.STAGE_CREATED, newStage);
      Notify.success("Etapa creada");
      this.$stageForm.reset();
    } catch (ex) {
      console.log(ex);
      Notify.error("Error al crear Etapa");
    }
  };
  updateStage = async (stage: Stage) => {
    try {
      await this.stagesClient.put(stage.id, stage);

      this.eventEmitter.emit(events.STAGE_UPDATED, stage);
      Notify.success("Etapa editada");
      this.formResetHandler();
      this.$stageForm.reset();
    } catch (ex) {
      console.log(ex);
      Notify.error("Error al editar Etapa");
    }
  };
}
